import { AllowedProductsAction } from "./actions";
import * as actionTypes from "./actionTypes";

export function reducer(state: string[] = null, action: AllowedProductsAction) {
    switch (action.type) {
        case actionTypes.LOAD_ALLOWED_PRODUCTS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
